<template>
    <div class="app-calendar app-mobile-calendar" role="region" aria-label="Mobile weekly menu calendar">
        <div v-for="n in dayMap.length" :key="'cat-row-' + n" class="app-calendar-day" role="group" :aria-label="'Menu for ' + dayMap[n-1]">
            <div class="app-calendar-day-title" role="heading" aria-level="3">{{ dayMap[n-1] }}</div>

            <div v-if="!days[n-1] || days[n-1].DayMenuItems.length === 0" class="app-calendar-empty-day-cell" :aria-label="'No menu scheduled for this day for ' + dayMap[n-1]">{{ days[n-1] && days[n-1].NonOperatingPeriodName || 'No menu scheduled for this day' }}</div>

            <fragment v-else>
                <div v-for="(category, category_index) in Object.values(categories)" :key="'cat-row-' + category_index" class="app-calendar-category-row" role="group" :aria-label="category.CategoryName + ' category for ' + dayMap[n-1]">
                    <div class="app-calendar-day-cell">
                        <div class="app-calendar-category-title" role="heading" aria-level="4"><b>{{ category.CategoryName }}</b></div>
                        <ul v-if="category.MenuItemsByDay[n] && category.MenuItemsByDay[n].MenuItems.length" class="app-calendar-item-list" role="list" :aria-label="category.CategoryName + ' menu items'">
                            <li v-for="(item, item_index) in category.MenuItemsByDay[n].MenuItems" :key="item_index">
                                <button
                                    v-if="!item.IsPlaceholder"
                                    :id="'app-subject-' + n + '-' + item.Name.replaceAll(' ', '-') + '-' + item_index"
                                    :data-day-number="n"
                                    @click="openMenuItemDetails(item.MenuItemId)"
                                    class="app-calendar-item"
                                    :aria-label="item.Name + ', ' + category.CategoryName + ' for ' + dayMap[n-1] + '. Click for details.'"
                                >
                                    {{ item.Name }}
                                </button>
                            </li>
                        </ul>
                    </div>
                </div>
            </fragment>
            
            
        </div>
    </div>
</template>

<script>
import { Fragment } from 'vue-frag';

export default {
    name: 'MobileCalendar',
    components: {
        'fragment': Fragment
    },
    props: {
        dayMap: {
            type: Array,
            required: true
        },
        categories: {
            type: Object,
            required: true
        },
        days: {
            type: Array,
            required: true
        }
    },
    methods: {
        openMenuItemDetails(menuItemId) {
            this.$emit('menu-item-selected', menuItemId);
        }
    }
}
</script>